module.exports = __webpack_public_path__ + "img/moon_rat_rotate.2f44e85f.svg";